import { CommonReduxState } from '@src/models/commons/reduxState.interface';

import { areAllDivisionsSelected } from '../utils/areAllDivisionsSelected';

export const selectAreAllDivisionsSelected = (state: CommonReduxState): boolean =>
  areAllDivisionsSelected(
    state.divisions?.selector?.ids,
    state.divisions?.assigned?.data?.divisions,
  );
